<script>
    import { capitalize } from '@modules/shared/filters';
    import { GameCategory } from '@core/services/game/GameService';
    import { routeNames } from '@app/router';
    import { slugify } from '@app/utils/slugify';

    // requires LoginRequiredMixin to work
    export default {
        data() {
            return {
                afterLogoutAction() {
                    if (this.$route.params.categorySlug === slugify(GameCategory.favourites)) {
                        this.$router.push({
                            params: {
                                categorySlug: slugify(GameCategory.slots),
                            }
                        });
                    }
                },
                categories: Object.keys(GameCategory).map((category) => ({
                    type: GameCategory[category],
                    displayName: capitalize(this.$t(GameCategory[category])),
                })),
            };
        },
        computed: {
            selectedCategory() {
                switch (this.$route.params.categorySlug) {
                    case slugify(GameCategory.favourites):
                        return GameCategory.favourites;
                    case slugify(GameCategory.slots):
                        return GameCategory.slots;
                    case slugify(GameCategory.jackpot):
                        return GameCategory.jackpot;
                    case slugify(GameCategory.recommended):
                        return GameCategory.recommended;
                    case slugify(GameCategory.new):
                        return GameCategory.new;
                    case slugify(GameCategory.table):
                        return GameCategory.table;
                    default:
                        return GameCategory.recommended;
                }
            },
        },
        methods: {
            onCategoryClick(value) {
                if (value === GameCategory.casinoLive) {
                    this.$router.push({
                        name: routeNames.casinoLive,
                    });
                    return;
                }
                if (value === GameCategory.favourites) {
                    this.loginRequired(() => {
                        if (this.$route.params.categorySlug !== slugify(GameCategory.favourites)) {
                            this.$router.push({
                                params: {
                                    categorySlug: slugify(GameCategory.favourites),
                                },
                            });
                        }
                    }, () => this.$router.back());
                    return;
                }
                this.$router.push({
                    params: {
                        categorySlug: slugify(value),
                    },
                });
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/shared/components/Games/GamesNavigationMixin.vue